import React from 'react';
import {ResponsiveContainer, BarChart, XAxis,YAxis, Tooltip, Bar, CartesianGrid} from 'recharts';
import CustomTooltip from '../CustomTooltip'

class GraphTopTrackers extends React.Component {

  render() {
    const { data, t } = this.props
    const translatedData = data && data.map( item => {
      return {name: t(item.name), value: item.value}
    })
    return (
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={translatedData}>
            <CartesianGrid vertical={false}/>
            <XAxis dataKey="name"  tickLine={false} />
            <YAxis dataKey="value" allowDecimals={false} tickLine={false} />
            <defs>
              <linearGradient id="linear" x1="0%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%"   stopColor={this.props.colors.color1}/>
                <stop offset="100%" stopColor={this.props.colors.color2}/>
              </linearGradient>
            </defs>
            <Bar dataKey="value" fill="url(#linear)" barSize={95} />
            <Tooltip
              cursor={false}
              content={<CustomTooltip data={this.props.data} />}
              wrapperStyle={styles.wrapper}
              labelStyle={styles.label}
              itemStyle={styles.label}
              />
          </BarChart>
        </ResponsiveContainer>
    )
  }
}

export default GraphTopTrackers;

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none'
  },

  label: {
    fontSize: '11px'
  },

  container: {
    maxWidth: '500px',
    width: '100%'
  },

  title: {
    fontSize: '16px',
    color: '#485465'
  }

}



// WEBPACK FOOTER //
// ./src/components/GraphAmountCluster/index.jsx